// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IUserInviteStateResult,
}                               from '../interfaces';

const getUserInviteState = async ({
    test,
}: {
    test: boolean,
}): Promise<IUserInviteStateResult> => {
    const functions = getFunctions();
    const handleGetUserInviteState = httpsCallable<
        Record<
            string,
            boolean
        >,
        IUserInviteStateResult
    >(
        functions,
        'getUserInviteState',
    );
    return handleGetUserInviteState({
        test,
    }).then((result) => {
        const userInviteState = result.data as IUserInviteStateResult;
        return userInviteState;
    }).catch((err) => {
        throw err;
    });
};

export default getUserInviteState;
